





































































































































































import { LoadingService } from '@/services/loadingService';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Snotify } from '@/snotify/Snotify';
import { Funcionalidades } from '../../../config/funcionalidades';
import { ComponenteBase } from '../../../views/base/ComponenteBase';
import { SolicitarClaveService } from './SolicitarClave.service';

@Component({
  name: 'SolicitarClave',
})
export default class SolicitarClave extends Vue {
  //96941960-2

  SolicitarClaveService: SolicitarClaveService = new SolicitarClaveService();
  accionesTotales: any[];
  readonly funcionalidad: Funcionalidades = Funcionalidades.VerFacturacion;
  $snotify: Snotify;
  readonly loadingService = new LoadingService();
  dialog: boolean = false;
  dialogInvalidRut: boolean = false;
  dialogServiceResponse: boolean = false;
  messageServiceResponse: string = '';
  boton: boolean = true;
  submitted = false;
  rut: string = null;
  isValid = {
    form: false,
    rutEmpresa: false,
    nombre: false,
    apellido: false,
    rutUsuario: false,
    email: false,
    telefono: false,
  };

  dataForm = {
    RutCuenta: '',
    NombreSolicitante: '',
    ApellidoSolicitante: '',
    RutSolicitante: '',
    EmailSolicitante: '',
    TelefonoSolicitante: '',
  };

  dataValidate() {
    if (
      this.dataForm.ApellidoSolicitante === '' ||
      this.dataForm.EmailSolicitante === '' ||
      this.dataForm.NombreSolicitante === '' ||
      this.dataForm.EmailSolicitante === '' ||
      this.dataForm.RutCuenta === '' ||
      this.dataForm.TelefonoSolicitante === ''
    ) {
      return (this.boton = true);
    } else {
      return (this.boton = false);
    }
  }
  sendDataCrearSolicitud() {
    //this.dialog = false;
    if (this.isValid.rutEmpresa && this.isValid.rutUsuario) {
      this.postNewKey();
    } else {
      this.dialogInvalidRut = true;
    }
  }
  /*cambio($event: any) {
    console.log('event', $event);
  }*/
  validateRut(rut: string, tipo: string) {
    const sanitised = this.sanitiseRut(rut);
    const correlative = sanitised.slice(0, -1);
    const checkDigit = sanitised[sanitised.length - 1];
    const verifiedDigit = this.getCheckDigit(correlative);
    if (tipo == 'empresa') {
      this.isValid.rutEmpresa =
        checkDigit.toLowerCase() === verifiedDigit.toLowerCase();
      if (!this.isValid.rutEmpresa) {
        this.$snotify.error('El RUT Empresa ingresado no es válido', {
          timeout: 3000,
        });
      }
    } else {
      this.isValid.rutUsuario =
        checkDigit.toLowerCase() === verifiedDigit.toLowerCase();
      if (!this.isValid.rutUsuario) {
        this.$snotify.error('El RUT Solicitante ingresado no es válido', {
          timeout: 3000,
        });
      }
    }
  }
  sanitiseRut(rut: string): string {
    return rut.toString().replace(/[^\dKk]/g, '');
  }
  getCheckDigit(rut: string): string {
    const local = [...reverseStr(fullySanitiseRut(rut))];
    let sum = 0;
    let v = 2;
    for (let i = 0; i < local.length; i++, v < 7 ? v++ : (v = 2)) {
      sum += +local[i] * v;
    }

    const result = 11 - (sum % 11);
    if (result === 11) {
      return '0';
    } else if (result <= 9) {
      return result.toString();
    } else {
      return 'K';
    }
  }

  async postNewKey() {
    const axiosResponse = await this.SolicitarClaveService.postNewKey(
      this.dataForm
    );
    const msResponse = axiosResponse.data;
    console.log(msResponse);
    if (axiosResponse.status === 200) {
      if (msResponse.CODIGO_RESPUESTA == '1') {
        //console.log(msResponse.MensajeR);
        this.dialog = false;
        this.messageServiceResponse = msResponse.MENSAJE_RESPUESTA;
        this.dialogServiceResponse = true;
        this.dataForm.ApellidoSolicitante = '';
        this.dataForm.EmailSolicitante = '';
        this.dataForm.NombreSolicitante = '';
        this.dataForm.EmailSolicitante = '';
        this.dataForm.RutCuenta = '';
        this.dataForm.TelefonoSolicitante = '';
        this.dataForm.RutSolicitante = '';
      } else {
        this.$snotify.error(msResponse.MENSAJE_RESPUESTA, { timeout: 3000 });
      }
    } else {
      this.$snotify.error('Ha ocurrido un error. Intente nuevamente.', {
        timeout: 3000,
      });
    }
  }
}

function reverseStr(rut: string): string {
  return rut.split('').reduce((acc, char) => char + acc, '');
}

function fullySanitiseRut(rut: string): string {
  return rut.toString().replace(/\D/g, '');
}
